import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const TONE = { saved: 'text-emerald-700', saved_version: 'text-emerald-700', replaced: 'text-sky-700', failed: 'text-red-600', not_connected: 'text-amber-700' };

export const DriveLogTab = ({ api }) => {
  const [rows, setRows] = useState([]);
  const load = () => api.get('/drive/log?limit=200').then((r) => setRows(r.data.rows || [])).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="bg-white border border-[#E2E2DF] rounded-md overflow-hidden" data-testid="drive-log-tab">
      <div className="flex justify-between items-center px-4 py-2.5 bg-slate-50 border-b border-[#E2E2DF]">
        <div className="text-xs font-semibold text-slate-700">Last {rows.length} Drive events</div>
        <button data-testid="drive-log-refresh" onClick={load} className="inline-flex items-center gap-1 text-xs text-slate-600 hover:text-slate-900"><RefreshCw size={12} /> Refresh</button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[900px] text-[11px]">
          <thead className="text-left text-slate-500 uppercase tracking-wider text-[10px]">
            <tr><th className="px-4 py-2">When</th><th>Status</th><th>File</th><th>Folder</th><th>From</th><th>By</th></tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className="border-t border-[#F1EFEC]" data-testid={`drive-log-row-${i}`}>
                <td className="px-4 py-1.5 whitespace-nowrap text-slate-500">{r.at ? new Date(r.at).toLocaleString() : ''}</td>
                <td className={`font-semibold ${TONE[r.status] || 'text-slate-600'}`}>{(r.status || '').replace(/_/g, ' ')}{r.simulated ? ' · test' : ''}</td>
                <td className="font-mono">{r.name}{r.error ? <span className="block text-red-500">{r.error}</span> : null}</td>
                <td className="font-mono text-slate-500 max-w-[320px] truncate" title={r.folder_path}>{r.folder_path}</td>
                <td>{r.source}</td>
                <td className="text-slate-500">{r.user}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-400">No Drive activity yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
